module.exports = __webpack_public_path__ + "media/images/common/logo/logo-221487997eb3ade3958b9997a862bd45.svg";